"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGOptionArrow = void 0;
class CTGOptionArrow extends Phaser.GameObjects.Container {
    constructor(scene, name, base_offset, selectable, pointer_over, pointer_out, pointer_left, pointer_right) {
        super(scene);
        this.arrow = scene.add.sprite(-4, 0, 'arrow').setOrigin(0);
        this.add(this.arrow);
        this.text = scene.add.bitmapText(base_offset, 1, 'font', name.toUpperCase(), 6).setTint(0x0).setOrigin(0);
        this.add(this.text);
        this.update_text(name);
        this._base_offset = base_offset;
        let bounds_width = this.text.getTextBounds(true).local.width;
        this.arrow.x = -64 + base_offset + bounds_width;
        this.set_selectable(selectable);
        this.pointer_over = pointer_over;
        this.pointer_out = pointer_out;
        this.pointer_left = pointer_left;
        this.pointer_right = pointer_right;
        this.arrow.on('pointerover', () => {
            if (this.pointer_over)
                this.pointer_over();
        });
        this.arrow.on('pointerout', () => {
            if (this.pointer_over)
                this.pointer_out();
        });
        this.arrow.on('pointerdown', (pointer) => {
            if (pointer.rightButtonDown()) {
                if (this.pointer_right)
                    this.pointer_right();
            }
            else {
                if (this.pointer_left)
                    this.pointer_left();
            }
        });
    }
    set_selectable(selectable) {
        if (selectable) {
            this.arrow.setInteractive();
        }
        else {
            this.arrow.removeInteractive();
        }
    }
    update_text(new_text) {
        this.text.setText(new_text);
        this._base_offset = this._base_offset;
        let bounds_width = this.text.getTextBounds(true).local.width;
        this.arrow.x = -64 + this._base_offset + bounds_width;
    }
    animate_select() {
        if (this._active_tween) {
            this._active_tween.stop();
        }
        this._active_tween = this.scene.tweens.add({
            targets: this,
            x: 5,
            ease: 'Quad.easeOut',
            duration: 200,
        });
    }
    animate_deselect() {
        if (this._active_tween) {
            this._active_tween.stop();
        }
        this._active_tween = this.scene.tweens.add({
            targets: this,
            x: 0,
            ease: 'Quad.easeOut',
            duration: 200,
        });
    }
}
exports.CTGOptionArrow = CTGOptionArrow;
